import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { ArrowUpRight, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const initial = { name: "", email: "", company: "", message: "" };

export const ContactDialog = ({ source, onClose }) => {
  const [form, setForm] = useState(initial);
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.email.trim()) {
      toast.error("Please add your name and work email.");
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/demo-request`, { ...form, source });
      toast.success("Thank you — we'll be in touch shortly.");
      setForm(initial);
      onClose();
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={!!source} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-[#F7F5F0] border-[#3E2818]/15 rounded-2xl sm:max-w-md" data-testid="demo-request-modal">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl font-medium text-[#3E2818]">
            {source === "Book a Demo" ? "Book a Demo" : "Talk to us"}
          </DialogTitle>
          <DialogDescription className="text-[#3E2818]/60">
            Tell us a little about you — our team will reach out shortly.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4 mt-2">
          <div className="space-y-1.5">
            <Label htmlFor="c-name" className="text-[#3E2818]">Full name *</Label>
            <Input id="c-name" data-testid="demo-form-name-input" value={form.name} onChange={set("name")} placeholder="Jane Smith" className="bg-white" />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="c-email" className="text-[#3E2818]">Work email *</Label>
            <Input id="c-email" data-testid="demo-form-email-input" type="email" value={form.email} onChange={set("email")} placeholder="jane@company.com" className="bg-white" />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="c-company" className="text-[#3E2818]">Company</Label>
            <Input id="c-company" data-testid="demo-form-company-input" value={form.company} onChange={set("company")} placeholder="Acme Corp" className="bg-white" />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="c-message" className="text-[#3E2818]">What would you like to explore?</Label>
            <Textarea id="c-message" data-testid="demo-form-message-input" value={form.message} onChange={set("message")} placeholder="Tell us about your use case…" className="bg-white min-h-[90px]" />
          </div>
          <button type="submit" disabled={loading} className="btn-primary w-full disabled:opacity-60" data-testid="demo-form-submit-button">
            {loading ? <Loader2 size={17} className="animate-spin" /> : <>Submit <ArrowUpRight size={17} /></>}
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
